import { render, staticRenderFns } from "./ProtocolManageView.vue?vue&type=template&id=00d2efb6"
import script from "./ProtocolManageView.vue?vue&type=script&lang=js"
export * from "./ProtocolManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports